<script lang="ts">
	export let title: string;
	export let description: string;
</script>

<div class="px-20 py-6 sm:py-[6rem] sm:px-24 md:px-16 flex flex-col h-full text-accent-primary">
	<div class="text-h-16 lg:h-16 text-center pb-1">{title}</div>
	<div class="text-p-16 font-[200] text-center">{description}</div>
</div>
